import { alpha, Box, Input, List, ListItem, ListItemButton, ListItemText, Paper, styled, Typography } from '@mui/material';

export const MailBoxContainer = styled(Box)(({ theme }) => ({
    height: '100%',
    minHeight: 0,
    display: 'flex',
    padding: '24px',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
        padding: '0',
    },
    // '@media (min-width:1640px)': {
    //     maxWidth: '1640px',
    // },
}));

export const MailSideNavbar = styled(Paper)(({ theme }) => ({
    width: '20%',
    minWidth: 230,
    height: '100%',
    padding: `${theme.typography.generic.none} ${theme.typography.generic.xxxxxLarge}`,
}));

export const ListStyled = styled(List)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: `${theme.typography.generic.none}`,
    borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
}));

export const MailNavListItem = styled(ListItem)(({ theme }) => ({
    padding: 0,
    width: 'fit-content',
}));

export const MailNavListItemButton = styled(ListItemButton)(({ theme }) => ({
    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.medium}`,
    borderBottom: `1px solid transparent`,
    minHeight: '43px',

    '& svg': {
        width: 20,
        height: 20,
        color: theme.palette.text.secondary,
        marginRight: theme.typography.generic.xSmall,
    },

    // '&:hover': {
    //     backgroundColor: alpha(theme.palette.primary.main, 0.1),
    // },
}));
export const MailNavListItemText = styled(ListItemText)(({ theme }) => ({
    '& .MuiTypography-root.MuiTypography-body1': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.palette.text.primary,
        fontSize: theme.typography.customFontSize.medium,
        fontWeight: theme.typography.fontWeightSemiBold,
    },
}));

// MailMessagesList

export const MailMessagesListBox = styled(Paper)(({ theme }) => ({
    width: '40%',
    minWidth: 500,
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.typography.generic.xLarge} ${theme.typography.generic.xLarge}`,
    // margin: `${theme.typography.generic.none} ${theme.typography.generic.xLarge}`,
    background: theme.palette.background.neutralSecondary,
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
        width: '100%',
        minWidth: '100%',
        // margin: `${theme.typography.generic.none}`,

        padding: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: '100%',
        // margin: `${theme.typography.generic.none}`,

        padding: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
    },
}));

export const MailMessagesList = styled(List)(({ theme }) => ({
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    marginTop: theme.typography.generic.none,
    paddingTop: theme.typography.generic.none,
}));

export const MailMessageListItem = styled(ListItem)(({ theme }) => ({
    marginBottom: `${theme.typography.generic.none}`,
    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.none}`,
    paddingRight: theme.typography.generic.xxSmall,
}));
export const MailMessageListItemButton = styled(ListItemButton)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    border: `1px solid ${theme.palette.border.neutralPrimary}`,
    borderRadius: theme.typography.borderRadius.medium,
    backgroundColor: theme.palette.background.paper,
    padding: `${theme.typography.generic.xLarge} ${theme.typography.generic.xLarge}`,

    '&.active': {
        borderColor: `${theme.palette.border.brandPrimary}`,
    },
    '&:hover': {
        backgroundColor: theme.palette.background.neutralSecondary,
    },
    '& svg': {
        marginTop: theme.typography.generic.xxxSmall,
        marginRight: theme.typography.generic.xxSmall,

        width: 16,
        height: 16,

        strokeOpacity: '0.3',
        '&.active path': {
            strokeOpacity: '0',
            fill: '#F7AC16',
        },
    },
}));
export const MailMessageListItemTextBox = styled('div')(({ theme }) => ({
    flex: 1,
    width: '75%',
}));

export const SearchInput = styled(Input)(({ theme }) => ({
    color: theme.palette.common.black,
    background: theme.palette.background.default,

    border: `1px solid ${theme.palette.border.neutralPrimary}`,
    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.xSmall}`,

    maxHeight: 40,

    width: '100%',

    fontSize: theme.typography.customFontSize.small,

    fontWeight: theme.typography.fontWeightRegular,
    borderRadius: `${theme.typography.borderRadius.xxxSmall}`,

    '& svg': {
        width: 16,
        height: 16,
        color: theme.palette.common.black,
    },
}));

// MailMessageDetails
// export const ActonsBox = styled(Box)(({ theme }) => ({
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     padding: `${theme.typography.generic.small} ${theme.typography.generic.small}`,

//     '& svg': {
//         width: '20px',
//         height: '20px',
//         color: alpha(theme.palette.text.secondary, 0.4),
//     },
//     '& .active svg': {
//         color: theme.palette.background.neutralSecondary,
//         fill: theme.palette.background.neutralSecondary,
//     },
// }));
